var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterBg1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1240.965,
    height: 540.837,
    viewBox: "0 0 1240.965 540.837",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Path_60",
    "data-name": "Path 60"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1240.46484375 540.3369140625 L 0.499960333108902 540.3369140625 L 0.499960333108902 32.54964447021484 L 32.67477416992188 0.4999954998493195 L 1199.344970703125 0.4999954998493195 L 1240.46484375 39.17090606689453 L 1240.46484375 540.3369140625 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 32.881103515625 1 L 1 32.75714111328125 L 1 539.8369140625 L 1239.96484375 539.8369140625 L 1239.96484375 39.38674926757812 L 1199.14697265625 1 L 32.881103515625 1 M 32.4681396484375 0 L 1199.543334960938 0 L 1240.96484375 38.9544677734375 L 1240.96484375 540.8369140625 L 0 540.8369140625 L 0 32.34182739257812 L 32.4681396484375 0 Z",
    stroke: "none",
    fill: "#e5bf00"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterBg1);
export default __webpack_public_path__ + "static/media/footerBG1.7f7b5b48787f13a4db41bd5107788566.svg";
export { ForwardRef as ReactComponent };